import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-pick-up-question-modal',
  templateUrl: './pick-up-question-modal.component.html',
  styleUrls: ['./pick-up-question-modal.component.scss'],
})
export class PickUpQuestionModalComponent {
  @Input() platform: PlatformEnum;
  @Input() withIcon: boolean;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() leftButtonText: string;
  @Input() rightButtonText: string;
  @Input() leftIsTrue: boolean;
  @Input() isFrozen: boolean;
  platformRef = PlatformEnum;
  @Output() dismissEvent = new EventEmitter<boolean>();
  constructor() {}

  dismissModal(value: boolean) {
    this.dismissEvent.emit(value);
  }

  handleSubmission(value: boolean) {
    // left button emits true, so need to reverse
    // if modal needs right to be true
    if (this.leftIsTrue) {
      this.dismissEvent.emit(value);
    } else {
      this.dismissEvent.emit(!value);
    }
  }
}
